module.exports = [
    {
        "category": "Accommodation",
        "intent": "accommodation_service",
        "entity_key": "accommodation_entity",
        "entity_value": "accommodation"
    },
    {
        "category": "Tours & Attractions",
        "intent": "accommodation_service",
        "entity_key": "accommodation_entity",
        "entity_value": "tours_and_attractions"
    },
    {
        "category": "Outdoor Activities",
        "intent": "accommodation_service",
        "entity_key": "accommodation_entity",
        "entity_value": "outdoor_activities"
    },
    {
        "category": "Experiences",
        "intent": "accommodation_service",
        "entity_key": "accommodation_entity",
        "entity_value": "experiences"
    },
    {
        "category": "Sports",
        "intent": "accommodation_service",
        "entity_key": "accommodation_entity",
        "entity_value": "sports"
    },
    {
        "category": "Health & Wellness",
        "intent": "accommodation_service",
        "entity_key": "accommodation_entity",
        "entity_value": "health_and_wellness"
    },

    {
        "category": "Food & Drinks",
        "intent": "accommodation_service",
        "entity_key": "accommodation_entity",
        "entity_value": "food_and_drinks"
    },
    {
        "category": "Getaways",
        "intent": "accommodation_service",
        "entity_key": "accommodation_entity",
        "entity_value": "getaways"
    },

    {
        "category": "Arts & Entertainment",
        "intent": "accommodation_service",
        "entity_key": "accommodation_entity",
        "entity_value": "arts_and_entertainment"
    },
]